// extracted by mini-css-extract-plugin
export var centerList = "_jd-6";
export var centerLoc = "_jd-a";
export var centerName = "_jd-9";
export var centerOptionBody = "_jd-8";
export var centerRow = "_jd-7";
export var centerStatus = "_jd-b";
export var empty = "_jd-5";
export var externalIcon = "_jd-c";
export var fieldHeader = "_jd-2";
export var fieldHelp = "_jd-4";
export var fieldLabel = "_jd-3";
export var panel = "_jd-0";
export var removeBtn = "_jd-d";
export var section = "_jd-1";